<template>
    <div>
      <div style="display: flex; justify-content: flex-end">
        <Button type="primary" v-show="responsive" @click="showFilter=!showFilter">Filter</Button>
      </div>
        <Row v-show="showFilter" :gutter="15">
            <Col class="my-3" :xs="24" :sm="4" :md="4" :lg="4" >

                <DatePicker size="large" type="daterange" v-model="filterDate" placeholder="Pickup Date" placement="bottom-start"
                            :clearable="false" format="dd/MM/yyyy" style="width: 100%" @on-change="onChangeDate"></DatePicker>
            </Col>
            <Col class="my-3" :xs="24" :sm="4" :md="4" :lg="4" >
                <ApolloQuery size="large" class="filterInput" :query="query_SEARCH_CITY" :variables="{cityFilter: dealerCityFilter}"
                             :debounce="500" :skip="skip.dealerSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Order City" v-model="dealerCity" :clearable="true" element-id="clientCity"
                                          @on-clear="onClearCity('clientCity')" @on-search="onSearchCity($event, 'clientCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'clientCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Col class="my-3" :xs="24" :sm="4" :md="4" :lg="4" >
                <ApolloQuery class="filterInput" :query="query_SEARCH_CITY" :variables="{cityFilter: pickupCityFilter}"
                             :debounce="500" :skip="skip.pickupSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Pickup City" v-model="pickupCity" :clearable="true" element-id="pickupCity"
                                          @on-clear="onClearCity('pickupCity')" @on-search="onSearchCity($event, 'pickupCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'pickupCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Col class="my-3" :xs="24" :sm="4" :md="4" :lg="4" >
                <ApolloQuery class="filterInput" :query="query_SEARCH_CITY" :variables="{cityFilter: droppingCityFilter}"
                             :debounce="500" :skip="skip.dropSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Drop City" v-model="droppingCity" :clearable="true" element-id="dropCity"
                                          @on-clear="onClearCity('dropCity')" @on-search="onSearchCity($event, 'dropCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'dropCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Col class="my-3" :xs="24" :sm="4" :md="4" :lg="4" >
                <Input v-model="search" placeholder="Search..."/>
            </Col>
        </Row>

        <Row :gutter="10">

          <Col v-show="responsive" :xs="24">
            <Card icon="ios-options">
<!--              ({{toDoOrdersCount&&toDoOrdersCount.aggregate?toDoOrdersCount.aggregate.count:0}})-->
              Stages <br>
              <Select v-model="selectedStage" size="large">
                <Option v-for="(stage, index) in stages" :key="index" :value="stage">{{NewStageName[stage]}} ({{$data[stage]?Object.keys($data[stage]).length:''}})</Option>
              </Select>
            </Card>
          </Col>

        <Col v-show="!responsive" :lg="6">
        <Card icon="ios-options">
            <template slot="title">Stages ({{toDoOrdersCount&&toDoOrdersCount.aggregate?toDoOrdersCount.aggregate.count:0}})</template>
            <CellGroup>
            <Cell v-for="stage in stages" :selected="selectedStage==stage?true:false" :key="stage">
                        <div @click="selectedStage=stage" style="width: 100vw;text-transform: capitalize">{{NewStageName[stage]}} ({{$data[stage]?Object.keys($data[stage]).length:''}})</div>
                </Cell>
            </CellGroup>
        </Card>
        </Col>

        <Col :xs="24" :sm="18" :md="18" :lg="18" >
              <Card style="margin-top: 7px;" class="scroll-card">
                  <template slot="title">Order - <span style="text-transform: capitalize; ">{{NewStageName[selectedStage]}}</span></template>
                  <template v-for="stage in stages">

                    <Row :gutter="16">
                      <Col span="12">
                        <div v-if="$data[stage]=='' && selectedStage==stage"> No Orders available</div>
                      </Col>

                      <Col :xs="24" :sm="12" :md="12" :lg="12" v-for="(order,index) in $data[stage]" v-if="selectedStage==stage" :key="index">
                          <div @click="editOrder(order)">
                            <Card class="cardStyle">
                              <Row>
                                <div style="padding: 5px;">
                                  <h3 style="font-weight: 400;">#{{ order.orderNumber }}</h3>
                                </div>
                                <span class="priorityLabel" :class="'card-label mod-card-front card-label-'+priorityObj[order.priority]"></span>
                                <!--<a class="info" @click.stop="openOrderDetail(order)"><i class="fal fa-info-circle"></i></a>-->
                                <!--<a class="delete" @click.stop="prevent($event)"><i class="fal fa-trash-alt"></i></a>-->
                              </Row>
                              <Divider style="margin: 2px 0 0 0;"></Divider>
                              <Row>

                                <Col span="24">
                                  <div style="display: flex; justify-content: space-between; padding: 5px;">
                                    <h3 class="card-left" style="font-weight: 400; font-size: 22px; text-transform: uppercase;">{{order.pickuppartyobject.address[0].city}}</h3>
                                    <i class="fas fa-exchange card-center" style="margin-top: auto; margin-bottom: auto;"></i>
                                    <h3 class="card-right" style="font-weight: 400; font-size: 22px; text-transform: uppercase; color: #000b15; letter-spacing: 1.5px;">{{order.droppingpartyobject.address[0].city}}</h3>
                                  </div>
                                </Col>

                                <Divider style="margin: 2px 0 0 0;"></Divider>

                                <Col span="24">
                                  <div style="display: flex; justify-content: space-between; padding: 5px;">
                                      <template v-if="order.orderDetails&&order.orderDetails.pickupPoint&&order.orderDetails.pickupPoint.pickupPartyId">
                                          <Tooltip :content="order.orderDetails.pickupPoint.pickupPartyName" theme="dark">
                                              <h4 class="card-left" style="font-weight: 300; letter-spacing: 1.5px; text-transform: capitalize; ">{{order.orderDetails.pickupPoint.pickupPartyName}}</h4>
                                          </Tooltip>
                                      </template>
                                      <template v-else>
                                          <Tooltip :content="order.pickuppartyobject.name" theme="dark">
                                            <h4 class="card-left" style="font-weight: 300; letter-spacing: 1.5px; text-transform: capitalize; ">{{order.pickuppartyobject.name}}</h4>
                                          </Tooltip>
                                      </template>
                                    <i class="fas fa-exchange card-center"></i>
                                      <template v-if="order.orderDetails&&order.orderDetails.dropPoint&&order.orderDetails.dropPoint.dropPartyId">
                                          <Tooltip :content="order.orderDetails.dropPoint.dropPartyName" theme="dark">
                                              <h4 class="card-right" style="font-weight: 300; letter-spacing: 1.5px; text-transform: capitalize;">{{order.orderDetails.dropPoint.dropPartyName}}</h4>
                                          </Tooltip>
                                      </template>
                                      <template v-else>
                                           <Tooltip :content="order.droppingpartyobject.name" theme="dark">
                                               <h4 class="card-right" style="font-weight: 300; letter-spacing: 1.5px; text-transform: capitalize;">{{order.droppingpartyobject.name}}</h4>
                                           </Tooltip>
                                      </template>
                                  </div>
                                </Col>
                                <Divider style="margin: 2px 0 0 0;"></Divider>
                                <Col span="24">
                                  <div style="font-weight: 300; padding: 0px 5px; display: flex; justify-content: space-between;">
                                    <label style="font-size: 12px; color: #686e6f;">Material</label>
                                    <label style="font-size: 12px; color: #686e6f;">Quantity</label>
                                  </div>
                                  <div style="padding: 0px 5px 5px 5px; font-weight: 300; display: flex; justify-content: space-between;">
                                    <h4 class="card-left" style="font-weight: 300; width: 100%!important;">{{order.materials?order.materials.type:''}} {{order.materials?order.materials.boxes:''}} boxes</h4>
                                    <h4 class="card-right" style="font-weight: 300; width: 100%!important;">{{order.materials?order.materials.kg:''}} kg</h4>
                                  </div>
                                </Col>
                                <Divider style="margin: 2px 0 0 0;"></Divider>
                                <Col span="24">
                                  <div style="margin-top: 5px;">
                                    <template v-if="selectedStage=='pending_approval'">
                                      <Button @click.stop="updateOrder(order.id, Constants.internalStatus.approval)" :loading="loading">
                                          <span v-if="!loading">Approve</span>
                                          <span v-else>Loading...</span>
                                      </Button>
                                      <Button @click.stop="onReject(order.id, Constants.internalStatus.rejected)" :loading="rejectLoading">
                                          <span v-if="!rejectLoading">Reject</span>
                                          <span v-else>Loading...</span>
                                      </Button>
                                    </template>
                                    <template  v-if="selectedStage=='pickup_confirmation'">
                                      <Button @click.stop="onPickupConfirmation(order.orderDetails.id)">Confirm</Button>
                                    </template>
                                    <template v-if="selectedStage=='pickup_readiness'">
                                      <Button @click.stop="onPickupreadiness(order.orderDetails.id)">Confirm</Button>
                                    </template>
                                    <template v-if="selectedStage=='create_lr'">
                                      <Button @click.stop="onEnterLR(order.orderDetails.id, order.orderDetails.lrObject)">Enter LR</Button>
                                      <Button @click.stop="CreateLR(order.orderDetails.id, order.orderDetails.lrObject, 'NA')">Not Applicable</Button>
                                    </template>
                                    <template v-if="selectedStage=='send_pickup_email'">
                                      <Button @click.stop="onSendPickupEmail(order.orderDetails.id, order.orderDetails.lrObject)">Sent</Button>
                                    </template>


                                    <template v-if="selectedStage=='tempo_sent_for_pickup'">
                                      <Button @click.stop="updateOrder(order.id, Constants.internalStatus.tempoOnTheWayToPickupLoad)">Tempo Sent For Pickup</Button>
                                    </template>
                                    <template v-if="selectedStage=='tempo_reached_company'">
                                      <Button @click.stop="updateOrder(order.id, Constants.internalStatus.tempoWaitingForLoadingMaterial)">Tempo Reached Company</Button>
                                    </template>
                                      <template v-if="selectedStage=='material_loaded'">
                                      <Button @click.stop="updateOrder(order.id, Constants.internalStatus.underBillingProcess)">Material Loaded</Button>
                                    </template>
                                      <template v-if="selectedStage=='tempo_left_pickup_company'">
                                      <Button @click.stop="updateOrder(order.id, Constants.internalStatus.onTheWayToPickupCityWarehouse)">Tempo Left Pickup Company</Button>
                                    </template>



                                    <template v-if="selectedStage=='dispatch_verification'">
                                      <Button @click.stop="onDispatchVerification(order.orderDetails.id, order.internalstatus, order.id,
                                              order.orderDetails.dispactchVerification, order.materials, Constants.internalstatus.inProcessOfDeparture)">Verified</Button>
                                    </template>
                                    <template v-if="selectedStage=='eway_bill'">
                                      <Button @click.stop="openEwayDialog(order)">Enter Eway Details</Button>
                                    </template>
                                    <template v-if="selectedStage=='assign_local_transport'||selectedStage=='assign_transport_vehicle'">
                                      <Button @click.stop="onAssignVehicle(order, selectedStage)">Assign Vehicle</Button>
                                    </template>
                                    <template v-if="selectedStage=='to_load_in_truck'">
                                      <Button @click.stop="onLoadTruck(order.orderDetails.id)">Load Truck</Button>
                                    </template>
                                    <template v-if="selectedStage=='to_be_departed'">
                                      <!--<Button @click.stop="updateOrder(order.id, Constants.internalStatus.onTheWayToDropCityWarehouse)">Truck Departed</Button>-->
                                       <Button @click.stop="onDispatchVerification(order.orderDetails.id, order.internalstatus, order.id,
                                              order.orderDetails.dispactchVerification, order.materials, Constants.internalStatus.onTheWayToDropCityWarehouse)">Truck Departed</Button>
                                    </template>
                                    <template v-if="selectedStage=='to_be_arrived'">
                                      <Button @click.stop="onDispatchVerification(order.orderDetails.id, order.internalstatus, order.id,
                                              order.orderDetails.dispactchVerification, order.materials, Constants.internalStatus.atDestinationCityWarehouse)">Arrived</Button>
                                    </template>
                                    <template v-if="selectedStage=='awaiting_final_delivery'">
                                      <Button @click.stop="updateOrder(order.id, Constants.internalStatus.completed)">Delivered</Button>
                                    </template>
                                  </div>
                                </Col>

                              </Row>
                            </Card>
                          </div>
                          <!--{{order.orderNumber}} ({{order.pickuppartyobject.address[0].city}}-->
                              <!--<i class="fas fa-exchange-alt"></i> {{order.droppingpartyobject.address[0].city}})-->



                      </Col>
                    </Row>

                  </template>
              </Card>
        </Col>

        </Row>

        <Modal v-model="assignVehicleDialog">
            <div slot="header" style="text-transform: capitalize; ">{{NewStageName[selectedStage]}}</div>
            <vehicle-assignment :orderId="order.id" :isComponentLoadedInToDo="true" :vehicleTypeInToDo="vehicleType"
                                v-if="assignVehicleDialog" :toDoStage="toDoStage"></vehicle-assignment>
            <div slot="footer"></div>
        </Modal>

        <Modal v-model="ewayDialog" :mask-closable="false" width="450" draggable>
            <div slot="header"><strong>Enter Eway Details</strong></div>
            <div>
                <span style="font-size: 15px">Order Number: #{{ewayForm.order?ewayForm.order.orderNumber:''}}</span>
                <Form :model="ewayForm" :rules="ruleEwayForm" ref="ewayForm" :label-width="140">
                    <FormItem prop="ewayBillNo" label="Eway Bill No." style="margin: 8px 0px 20px -27px">
                        <Input v-model="ewayForm.ewayBillNo"/>
                    </FormItem>
                    <FormItem label="Eway Bill Verified">
                        <i-switch v-model="ewayForm.isEwayBillVerified" size="large">
                            <span slot="open">ON</span><span slot="close">OFF</span>
                        </i-switch>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button type="primary" style="font-weight: bolder" @click="addEwayBillDetails" :loading="loading">
                    <span v-if="!loading">SAVE</span>
                    <span v-else>Loading...</span>
                </Button>
                <Button style="background: #999999; color: white;font-weight: bolder" @click="ewayDialog=false">CANCEL</Button>
            </div>
        </Modal>

        <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"></manage-order>
    </div>
</template>

<script>
import {GET_PENDING_FOR_APPROVAL,GET_PICKUP_CONFIRMATION, GET_PICKUP_READINESS, GET_CREATE_LR, GET_SEND_PICKUP_EMAIL,
    GET_DISPATCH_VERIFICATION, GET_EWAY_BILL, GET_ASSIGN_TRANSPORT_VEHICLE, GET_ASSIGN_LOCAL_TRANSPORT, GET_TO_LOAD_IN_TRUCK,
    GET_TO_BE_DEPARTED, GET_TO_BE_ARRIVED, GET_AWAITING_FINAL_DELIVERY, GET_TEMPO_SENT_FOR_PICKUP,
    GET_TEMPO_REACHED_COMPANY, GET_MATERIAL_LOADED, GET_TEMPO_LEFT_PICKUP_COMPANY, GET_TODO_ORDERS_COUNT} from '../graphql/queries/ToDoOrders'
import {ADD_ORDER_DETAIL_UPDATE_ORDER, REJECT_ORDER} from '../graphql/mutations/orderDetails'
import {GET_ORDER_DETAIL} from '../graphql/queries/OrderDetails'
import {UPDATE_ORDER_BY_STATUS, UPDATE_ORDER_BY_MATERIALS} from '../graphql/mutations/orders'
import {PICKUP_CONFIRMATION, PICKUP_READINESS, SEND_PICKUP_EMAIL, DISPATCH_VERIFICATION,
    LOAD_TRUCK, ENTER_EWAY_BILL} from '../graphql/mutations/ToDoOrders'
import {SUBSCRIBE_PENDING_FOR_APPROVAL, SUBSCRIBE_PICKUP_CONFIRMATION, SUBSCRIBE_PICKUP_READINESS, SUBSCRIBE_CREATE_LR,
    SUBSCRIBE_SEND_PICKUP_EMAIL, SUBSCRIBE_DISPATCH_VERIFICATION, SUBSCRIBE_EWAY_BILL, SUBSCRIBE_ASSIGN_TRANSPORT_VEHICLE, SUBSCRIBE_ASSIGN_LOCAL_TRANSPORT,
    SUBSCRIBE_TO_LOAD_IN_TRUCK, SUBSCRIBE_TO_BE_DEPARTED, SUBSCRIBE_TO_BE_ARRIVED, SUBSCRIBE_AWAITING_FINAL_DELIVERY,
    SUBSCRIBE_TEMPO_SENT_FOR_PICKUP, SUBSCRIBE_TEMPO_REACHED_COMPANY, SUBSCRIBE_MATERIAL_LOADED, SUBSCRIBE_TEMPO_LEFT_PICKUP_COMPANY} from '../graphql/subscription/ToDoOrders'
import { SEARCH_CITY2 } from '../graphql/queries/territories'
import {generateUUID, Constants} from "../Constants/Constant";
import VehicleAssignment from './Manage Order/VehicleAssignment'
import ManageOrder from './Manage Order/ManageOrder'
import ValidationRules from '../Constants/ValidationRules'
import moment from 'moment'

    export default {
        apollo: {
            pending_approval: {
                query: GET_PENDING_FOR_APPROVAL,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_PENDING_FOR_APPROVAL,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.pending_approval = subscriptionData.data.pending_approval;
                        this.$forceUpdate()
                    },
                }
            },
            pickup_confirmation: {
                query: GET_PICKUP_CONFIRMATION,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_PICKUP_CONFIRMATION,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.pickup_confirmation = subscriptionData.data.pickup_confirmation;
                        this.$forceUpdate()
                    },
                }
            },
            pickup_readiness: {
                query: GET_PICKUP_READINESS,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_PICKUP_READINESS,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.pickup_readiness = subscriptionData.data.pickup_readiness;
                        this.$forceUpdate()
                    },
                }
            },
            create_lr: {
                query: GET_CREATE_LR,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_CREATE_LR,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.create_lr = subscriptionData.data.create_lr;
                        this.$forceUpdate()
                    },
                }
            },
            send_pickup_email: {
                query: GET_SEND_PICKUP_EMAIL,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_SEND_PICKUP_EMAIL,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.send_pickup_email = subscriptionData.data.send_pickup_email;
                        this.$forceUpdate()
                    },
                }
            },
            dispatch_verification: {
                query: GET_DISPATCH_VERIFICATION,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_DISPATCH_VERIFICATION,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.dispatch_verification = subscriptionData.data.dispatch_verification;
                        this.$forceUpdate()
                    },
                }
            },
            eway_bill: {
                query: GET_EWAY_BILL,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_EWAY_BILL,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.eway_bill = subscriptionData.data.eway_bill;
                        this.$forceUpdate()
                    },
                }
            },
            assign_local_transport: {
                query: GET_ASSIGN_LOCAL_TRANSPORT,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_ASSIGN_LOCAL_TRANSPORT,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.assign_local_transport = subscriptionData.data.assign_local_transport;
                        this.$forceUpdate()
                    },
                }
            },
            tempo_sent_for_pickup: {
                query: GET_TEMPO_SENT_FOR_PICKUP,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_TEMPO_SENT_FOR_PICKUP,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.tempo_sent_for_pickup = subscriptionData.data.tempo_sent_for_pickup;
                        this.$forceUpdate()
                    },
                }
            },
            tempo_reached_company: {
                query: GET_TEMPO_REACHED_COMPANY,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_TEMPO_REACHED_COMPANY,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.tempo_reached_company = subscriptionData.data.tempo_reached_company;
                        this.$forceUpdate()
                    },
                }
            },
            material_loaded: {
                query: GET_MATERIAL_LOADED,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_MATERIAL_LOADED,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.material_loaded = subscriptionData.data.material_loaded;
                        this.$forceUpdate()
                    },
                }
            },
            tempo_left_pickup_company: {
                query: GET_TEMPO_LEFT_PICKUP_COMPANY,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_TEMPO_LEFT_PICKUP_COMPANY,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.tempo_left_pickup_company = subscriptionData.data.tempo_left_pickup_company;
                        this.$forceUpdate()
                    },
                }
            },
            assign_transport_vehicle: {
                query: GET_ASSIGN_TRANSPORT_VEHICLE,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_ASSIGN_TRANSPORT_VEHICLE,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.assign_transport_vehicle = subscriptionData.data.assign_transport_vehicle;
                        this.$forceUpdate()
                    },
                }
            },
            to_load_in_truck: {
                query: GET_TO_LOAD_IN_TRUCK,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_TO_LOAD_IN_TRUCK,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.to_load_in_truck = subscriptionData.data.to_load_in_truck;
                        this.$forceUpdate()
                    },
                }
            },
            to_be_departed: {
                query: GET_TO_BE_DEPARTED,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_TO_BE_DEPARTED,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.to_be_departed = subscriptionData.data.to_be_departed;
                        this.$forceUpdate()
                    },
                }
            },
            to_be_arrived: {
                query: GET_TO_BE_ARRIVED,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_TO_BE_ARRIVED,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.to_be_arrived = subscriptionData.data.to_be_arrived;
                        this.$forceUpdate()
                    },
                }
            },
            awaiting_final_delivery: {
                query: GET_AWAITING_FINAL_DELIVERY,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_AWAITING_FINAL_DELIVERY,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: this.searchFilter
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.awaiting_final_delivery = subscriptionData.data.awaiting_final_delivery;
                        this.$forceUpdate()
                    },
                }
            },
            toDoOrdersCount: {
                query: GET_TODO_ORDERS_COUNT,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                }
            }
        },
        name: "ToDoList",
        components:{VehicleAssignment, ManageOrder},
        provide() {
            return {
                getManageOrderDrawer: () => this.manageOrderDrawer,
                setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
                getOrder: () => this.order,
                closeAssignVehicleDialog: (data) => { this.assignVehicleDialog = data },
            }
        },
        data: function(){
            return{
            Constants: Constants,
            stages: ['pending_approval', 'pickup_confirmation', 'pickup_readiness', 'create_lr', 'send_pickup_email',
                     'assign_local_transport', 'tempo_sent_for_pickup','tempo_reached_company','material_loaded',
                     'tempo_left_pickup_company', 'dispatch_verification', 'eway_bill', 'assign_transport_vehicle', 'to_load_in_truck',
                     'to_be_departed', 'to_be_arrived', 'awaiting_final_delivery'], /* --- add_billing_amount --*/
            selectedStage: 'pending_approval',
            rejectNote: '',
            lrName: '',
            dispatch_finalQty: '',
            dispatch_finalWt: 0,
            dispatch_breakageQty: 0,
            dispatch_breakageNote: 0,
            dispatch_missingQty: 0,
            dispatch_missingNote: 0,
            assignVehicleDialog: false,
            priorityObj: {0: 'Low', 1: 'Normal', 2: 'High'},
            selectedOrder: '',
     /* -------- Filters variables ----------------- */
            query_SEARCH_CITY: SEARCH_CITY2,
            filterDate: [moment().subtract(30, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
            startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            dealerCity: '',
            pickupCity: '',
            droppingCity: '',
            selectedDealerCity: {"address":[]},
            selectedPickupCity: {"address":[]},
            selectedDroppingCity: {"address":[]},
            skip: {dealerSkip: true, pickupSkip: true, dropSkip: true}, //To Avoid calls at initial
            dealerCityFilter: '%%',
            pickupCityFilter: '%%',
            droppingCityFilter: '%%',
            search: '',
     /* -------x---------x--------x------------x---- */
    /* -------- Edit Order variables ----------------- */
            orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
            manageOrderDrawer: false,
            order: '',
            viewPath: '',
            vehicleType: '',
            toDoStage: '',
    /* -------x---------x--------x------------x---- */
            loading: false,
            rejectLoading: false,
    /* --------- Eway Bill variables ------------------ */
            ewayDialog: false,
            ewayForm: { ewayBillNo:'', isEwayBillVerified:false, order: null },
            ruleEwayForm: { ewayBillNo: ValidationRules.textField('Eway Bill No.'), },
    /* -------x---------x--------x-------------x---- */
              showFilter: true,
              responsive:false,
              NewStageName : {
                    'pending_approval' : 'Accept Order from Other branch',
                    'pickup_confirmation' : 'Confirm order from pickup point',
                    'pickup_readiness': 'Clear order for Pickup',
                    'create_lr': 'Create LR',
                    'send_pickup_email': 'Send Vehicle SMS/E-mail',
                    'assign_local_transport': 'Select Local Vehicle',
                    'tempo_sent_for_pickup': 'Send Vehicle for pickup material',
                    'tempo_reached_company': 'Submit LR in Company',
                    'material_loaded': 'Material Loading Complete',
                    'tempo_left_pickup_company': 'Receive Bill and leave Pickup Company',
                    'dispatch_verification': 'Verify Material',
                    'eway_bill': 'Generate E-way bill',
                    'assign_transport_vehicle': 'Select Transport Vehicle',
                    'to_load_in_truck': 'Load material in Transport Vehicle',
                    'to_be_departed': 'Verify Paper and Depart material',
                    'to_be_arrived': 'Verify incoming material',
                    'awaiting_final_delivery': 'Deliver Material',
                }
            }
        },
        computed: {
            searchFilter () {
                return '%' + this.search + '%'
            }
        },
        methods: {
          onResponsiveInverted() {
            if (window.innerWidth < 991) {
              this.responsive = true
              this.showFilter = false
            } else {
              this.responsive = false
            }
          },
            getStageName(stage){
                return stage.replace(/_/g, ' ');
            },
            editOrder(order){
                this.orderId = order.id;
                this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
                this.order = order;
                // this.$refs['manage-order-page'].$refs['order-detail-page'].$apollo.queries.orders.skip = false;
                this.manageOrderDrawer = true;
            },
            onChangeDate(evt){
                this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
                this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
            },
            onSearchCity(event, str){
                if(str === 'clientCity'){
                    this.dealerCityFilter = '%' + this.dealerCity + '%';
                    this.skip.dealerSkip = false;
                }else if(str === 'pickupCity'){
                    this.pickupCityFilter = '%' + this.pickupCity + '%';
                    this.skip.pickupSkip = false;
                }else if(str === 'dropCity'){
                    this.droppingCityFilter = '%' + this.droppingCity + '%';
                    this.skip.dropSkip = false;
                }
            },
            onSelectCity(city, str){
                if(str === 'clientCity'){
                    this.selectedDealerCity = {"address":[{"city": city}]};
                }else if(str === 'pickupCity'){
                    this.selectedPickupCity = {"address":[{"city": city}]};
                }else if(str === 'dropCity'){
                    this.selectedDroppingCity = {"address":[{"city": city}]};
                }
            },
            onClearCity(str){
                if(str === 'clientCity'){
                    this.selectedDealerCity = {"address":[]};
                }else if(str === 'pickupCity'){
                    this.selectedPickupCity = {"address":[]};
                }else if(str === 'dropCity'){
                    this.selectedDroppingCity = {"address":[]};
                }
            },
            openEwayDialog(order){
                this.$refs['ewayForm'].resetFields()
                this.ewayForm.order = order
                this.ewayForm.isEwayBillVerified = false
                this.ewayDialog = true
            },
            addEwayBillDetails(){
              this.loading = true;
              this.$refs['ewayForm'].validate((valid) => {
                    if (valid) {
                        this.insertEwayBillDetails();
                    }else{
                        this.loading = false
                    }
              })
            },
            async insertEwayBillDetails(){
                let response = await this.$apollo.mutate({
                    mutation: ENTER_EWAY_BILL,
                    variables: {
                        orderDetailId: this.ewayForm.order.orderDetails.id,
                        ewayBillNo: this.ewayForm.ewayBillNo,
                        isEwayBillVerified: this.ewayForm.isEwayBillVerified
                    }
                })
                if(response.data){
                    this.$Message.success('Eway bill details added successfully!')
                    this.$refs['ewayForm'].resetFields()
                    this.loading = false;
                    this.ewayDialog = false;
                }
            },
            onReject(id, internalStatusId){
                this.rejectLoading = true
                this.rejectNote = '';
                this.$Modal.confirm({
                    title: 'Reject Note',
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.rejectNote,
                                autofocus: true,
                                placeholder: 'Please enter Note'
                            },
                            on: {
                                input: (val) => {
                                    this.rejectNote = val;
                                }
                            }
                        })
                    },
                    onOk: () => {
                        this.rejectOrder(id, internalStatusId)
                         },
                    onCancel: () => {
                        this.rejectLoading = false
                    }
                })
            },
            async rejectOrder(orderId, internalStatusId){
                let response = await this.$apollo.mutate({
                    mutation: REJECT_ORDER,
                    variables: {
                        orderId: orderId,
                        internalstatus: internalStatusId,  //Change internalStatusId to specific argument passed
                        rejectionNote: this.rejectNote
                    }
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!');
                    this.rejectLoading = false
                }
            },
            async addOrderDetail_UpdateOrder(id, internalStatusId){
                this.loading = true;
            /* -------- Check if any orderDetail already exists on parent orderId ------- */
                let queryResponse = await this.$apollo.query({
                    query: GET_ORDER_DETAIL,
                    variables: {orderId: id},
                    fetchPolicy: "network-only"
                })
                if(queryResponse.data.orderDetails.length){
                 this.loading = false
                 this.rejectLoading = false
                 return
                }
            /* -------------x----------------x-------------------x---------------x--------- */
                console.log('after return')
                let response = await this.$apollo.mutate({
                    mutation: ADD_ORDER_DETAIL_UPDATE_ORDER,
                    variables: {
                        id: generateUUID(),
                        orderReadiness: {
                            isOrderReady: false,
                            pickupDate: ''
                        },
                        lrObject: {
                            islrReady: false,
                            isEmailSent: false
                        },
                        pickupConfirmation: 'Awaiting',
                        pickupPoint: {
                            pickupPartyName: '',
                            pickupPartyId: '',
                            mobile: '',
                            email: '',
                            add1: '',
                            add2: '',
                            area: '',
                            pincode: '',
                            city: '',
                            state: ''
                        },
                        dropPoint: {
                            dropPartyName: '',
                            dropPartyId: '',
                            mobile: '',
                            email: '',
                            add1: '',
                            add2: '',
                            area: '',
                            pincode: '',
                            city: '',
                            state: ''
                        },
                        orderId: id,
                        orderDetailId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                        internalstatus: internalStatusId,
                        rejectionNote: internalStatusId==='912cba99-37cb-41fb-ae2e-2a472200af64' ? this.rejectNote : ''
                    }
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!');
                    this.loading = false
                    this.rejectLoading = false
                }
            },
            async onPickupConfirmation(orderDetailId){
                let response = await this.$apollo.mutate({
                    mutation: PICKUP_CONFIRMATION,
                    variables: {
                        orderDetailId: orderDetailId,
                        pickupConfirmation: 'Done',
                    }
                })
                if(response.data){
                    this.$Message.success('OrderDetail updated successfully!');
                }
            },
            async onLoadTruck(orderDetailId){
                let response = await this.$apollo.mutate({
                    mutation: LOAD_TRUCK,
                    variables: {
                        orderDetailId: orderDetailId,
                        loadedInTruck: true,
                    }
                })
                if(response.data){
                    this.$Message.success('OrderDetail updated successfully!');
                }
            },
            async onPickupreadiness(orderDetailId){
                let response = await this.$apollo.mutate({
                    mutation: PICKUP_READINESS,
                    variables: {
                        orderDetailId: orderDetailId,
                        orderReadiness: {
                            isOrderReady: true,
                            pickupDate: ''
                        }
                    }
                })
                if(response.data){
                    this.$Message.success('OrderDetail updated successfully!');
                }
            },
            onEnterLR(orderDetailId, lrObject){
                this.lrName = '';
                this.$Modal.confirm({
                    title: 'LR Name',
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.lrName,
                                autofocus: true,
                                placeholder: 'Please enter LR Name'
                            },
                            on: {
                                input: (val) => {
                                    this.lrName = val;
                                }
                            }
                        })
                    },
                    onOk: () => {
                        this.CreateLR(orderDetailId, lrObject, this.lrName)
                    }
                })
            },
            async CreateLR(orderDetailId, lrObject, lrName){
                let response = await this.$apollo.mutate({
                    mutation: SEND_PICKUP_EMAIL,
                    variables: {
                        orderDetailId: orderDetailId,
                        lrObject: {
                            islrReady: true,
                            isEmailSent: lrObject.isEmailSent,
                            lrName: lrName
                        },
                    }
                })
                if(response.data){
                    this.$Message.success('OrderDetail updated successfully!');
                }
            },
            onDispatchVerification(orderDetailId, internalStatusId, orderId, dispactchVerification, materials, updateBy_internalStatusId){
                this.dispatch_finalQty = '';
                this.dispatch_finalWt = 0;
                this.dispatch_breakageQty = 0;
                this.dispatch_breakageNote = '';
                this.dispatch_missingQty = 0;
                this.dispatch_missingNote = '';
                this.$Modal.confirm({
                    title: 'Enter Dispatch Details',
                    render: (h) => {
                        return h('div',{style:{paddingBottom:'16px'}}, [[h('p','Final Qty:'),h('Input',{
                            style: {
                                width: '70%',
                                marginBottom: '8px',
                                marginTop: '-25px',
                                float: 'right'
                            },
                            props: {
                                value: this.dispatch_finalQty,
                                autofocus: true,
                                placeholder: 'Final Quantity',

                            },
                            on: {
                                input: (val) => {
                                    this.dispatch_finalQty = val;
                                }
                            }
                        })],
                            [h('p',{style:{marginTop:'16px'}, domProps:{innerHTML:'Final Wt:'}}), h('Input', {
                            style: {
                                width: '70%',
                                marginBottom: '8px',
                                marginTop: '-25px',
                                float: 'right'
                            },
                            props: {
                                value: this.dispatch_finalWt,
                                placeholder: 'Enter Final Weight'
                            },
                            on: {
                                input: (val) => {
                                    this.dispatch_finalWt = val;
                                }
                            }
                        })],
                            [h('p',{style:{marginTop:'16px'}, domProps:{innerHTML:'Breakage Qty'}}), h('Input', {
                                style: {
                                    width: '70%',
                                    marginBottom: '8px',
                                    marginTop: '-25px',
                                    float: 'right'
                                },
                                props: {
                                    value: this.dispatch_breakageQty,
                                    placeholder: 'Breakage Qty'
                                },
                                on: {
                                    input: (val) => {
                                        this.dispatch_breakageQty = val;
                                    }
                                }
                            })],
                            [h('p',{style:{marginTop:'16px'}, domProps:{innerHTML:'Breakage Note'}}), h('Input', {
                                style: {
                                    width: '70%',
                                    marginBottom: '32px',
                                    marginTop: '-25px',
                                    float: 'right'
                                },
                                props: {
                                    value: this.dispatch_breakageNote,
                                    placeholder: 'Breakage Note',
                                    type: 'textarea'
                                },
                                on: {
                                    input: (val) => {
                                        this.dispatch_breakageNote = val;
                                    }
                                }
                            })],
                            [h('p',{style:{marginTop:'40px'}, domProps:{innerHTML:'Missing Qty:'}}), h('Input', {
                                style: {
                                    width: '70%',
                                    marginBottom: '8px',
                                    marginTop: '-25px',
                                    float: 'right'
                                },
                                props: {
                                    value: this.dispatch_missingQty,
                                    placeholder: 'Missing Qty'
                                },
                                on: {
                                    input: (val) => {
                                        this.dispatch_missingQty = val;
                                    }
                                }
                            })],
                            [h('p',{style:{marginTop:'16px'}, domProps:{innerHTML:'Missing Note:'}}), h('Input', {
                                style: {
                                    width: '70%',
                                    marginBottom: '8px',
                                    minHeight: '8px !important',
                                    height: '8px !important',
                                    marginTop: '-25px',
                                    float: 'right'
                                },
                                props: {
                                    value: this.dispatch_missingNote,
                                    placeholder: 'Missing Note',
                                    type: 'textarea'
                                },
                                on: {
                                    input: (val) => {
                                        this.dispatch_missingNote = val;
                                    }
                                }
                            })]
                        ])
                    },
                    onOk: () => {
                        this.CreateDispatchVerification(orderDetailId, internalStatusId, dispactchVerification)
                        if(this.dispatch_finalQty||this.dispatch_finalWt){this.updateOrderByMaterials(materials, orderId)}
                        this.updateOrder(orderId, updateBy_internalStatusId) //update by internalStatusId
                    }
                })
            },
            onAssignVehicle(order, stage){
                this.toDoStage = stage
                this.order = order;
                this.assignVehicleDialog = true;
            },
            async CreateDispatchVerification(orderDetailId, internalStatusId, dispactchVerification){
                let dv = []
                if(dispactchVerification && Object.prototype.toString.call(dispactchVerification) == '[object Array]'){
                    dv = dispactchVerification;
                }
                dv.unshift({
                    createdAt : moment().format('DD-MM-YYYY HH:MM:ss a'),
                    internalStatusId: internalStatusId,
                    finalQuantity: this.dispatch_finalQty,
                    finalWeight: this.dispatch_finalWt,
                    breakageQuantity: this.dispatch_breakageQty,
                    breakageNote: this.dispatch_breakageNote,
                    missingQuantity: this.dispatch_missingQty,
                    missingNote: this.dispatch_missingNote,
                })


                let response = await this.$apollo.mutate({
                    mutation: DISPATCH_VERIFICATION,
                    variables: {
                        orderDetailId: orderDetailId,
                        dispactchVerification: dv,
                    }
                })
                if(response.data){
                    this.$Message.success('OrderDetail updated successfully!');
                }
            },
            async onSendPickupEmail(orderDetailId, lrObject){
                let response = await this.$apollo.mutate({
                    mutation: SEND_PICKUP_EMAIL,
                    variables: {
                        orderDetailId: orderDetailId,
                        lrObject: {
                            islrReady: lrObject.islrReady,
                            isEmailSent: true,
                            lrName: lrObject.lrName?lrObject.lrName:''
                        },
                    }
                })
                if(response.data){
                    this.$Message.success('OrderDetail updated successfully!');
                }
            },
            async updateOrder(orderId, internalStatusId){
                this.loading = true
                let response = await this.$apollo.mutate({
                    mutation: UPDATE_ORDER_BY_STATUS,
                    variables: {
                        orderId: orderId,
                        internalstatus: internalStatusId,  //Change internalStatusId to specific argument passed
                    }
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!');
                    this.loading = false
                }
            },
            async updateOrderByMaterials(materials, orderId){
                if(this.dispatch_finalQty){materials.boxes = this.dispatch_finalQty}
                if(this.dispatch_finalWt){materials.kg = this.dispatch_finalWt}
                let response = await this.$apollo.mutate({
                    mutation: UPDATE_ORDER_BY_MATERIALS,
                    variables: {
                        orderId: orderId,
                        materials: materials,
                    }
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!');
                }
            },
        },
        mounted(){
            this.onResponsiveInverted();
            window.addEventListener('resize', this.onResponsiveInverted);
            document.querySelector("#clientCity").setAttribute("autocomplete", "new-password");
            document.querySelector("#pickupCity").setAttribute("autocomplete", "new-password");
            document.querySelector("#dropCity").setAttribute("autocomplete", "new-password");
        },
      beforeDestroy() {
        window.removeEventListener('resize', this.onResponsiveInverted)
      },
    }
</script>

<style scoped>
    /deep/ .scroll-card > .ivu-card-body{
        height: 79vh;
        overflow-y: auto;
    }

    /deep/ .ivu-dropdown-item{
        padding: 0px 0px;
    }
    .ivu-dropdown-item-div{
        padding: 7px 16px;
        width: 100%;
    }
    .row {
        display: flex;
    }
    .col-3{
        width: 25%
    }
    /deep/ .ivu-input{
        font-size: 14px !important;
        border-radius: 5px;
        font-size: 14px;
    }
    /*.filterInput{*/
    /*    width: 80%;*/
    /*}*/
    /deep/ .ivu-date-picker-cells  {
        font-size: 12px !important;
    }
  .cardStyle{
    background: #fff !important;
    border-radius: 10px;
    box-shadow: 0px 2px 5px -3px;
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .cardStyle:hover{
    box-shadow: 0px 2px 7px -2px !important;
  }
  /*.cardStyle:before{*/
  /*content: '';*/
  /*width: 30px;*/
  /*height: 80px;*/
  /*background: #596363;*/
  /*position: absolute;*/
  /*right: 0px;*/
  /*top: 55px;*/
  /*z-index: 99;*/
  /*box-shadow: -3px 2px 5px -2px #686e6f;*/
  /*}*/
  .priorityLabel{
    position: absolute;
    top: 10px;
    right: 0px;

  }
  .card-left{
    letter-spacing: 1.5px;
    color: #000b15;
    width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
  }
  .card-center{
    margin-top: auto;
    text-align: center;
    margin-bottom: auto;
    width: 116px;
  }
  .card-right{
    width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
    font-size: 14px;
  }
  .info{
    position: absolute;
    top: 7px;
    right: 25px;
    font-size: 16px;
    color: #596363;
  }
  .delete{
    position: absolute;
    top: 7px;
    right: 0px;
    font-size: 16px;
    color: #EB5A46;
  }
  .my-3{
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
  }
  .float-right{
    float: right;
  }
</style>
